// Components==============
import { motion } from 'framer-motion';
import React from 'react';
import './CheckBoxBar.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckSquare, faSquare } from '@fortawesome/pro-solid-svg-icons';
// =========================

export default function CheckBoxBar({ children, onClick, active }) {
    return (
        <motion.div
            styleName={`checkbox-bar ${active ? 'active' : ''}`}
            onClick={onClick}
            whileHover={{ scale: 1.01 }}
            whileTap={{ scale: 0.99 }}
        >
            <FontAwesomeIcon icon={active ? faCheckSquare : faSquare} />
            {children}
        </motion.div>
    );
}
